module.exports = __webpack_public_path__ + "img/headphone.497efcc1.svg";